import { Component, OnInit } from '@angular/core';
import { AuthorizationCheckService } from './service/authorization-check.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'PCCFWLNEW';
constructor(private authorizationCheckService: AuthorizationCheckService) {}
ngOnInit() {
      const menuStr = JSON.parse(sessionStorage.getItem("link"));
    if (menuStr) {
      try {
        this.authorizationCheckService.setAllowedLinks(menuStr);
      } catch (e) {
        // If JSON parsing fails, clear it to avoid blocking user
        localStorage.removeItem('link');
      }
    }
  }
}
